import axios from 'axios';

export {
  LEFTOVER_API_ORIGIN,
  branchApiOrigin,
  leftoverApiOrigin,
  isLeftoverFrontendHost,
  isProductionFrontendHost,
  resolveBackendRoot,
  apiUrl,
} from './apiRoot.js';
import { apiUrl } from './apiRoot.js';

const apiBase = () => apiUrl();

const api = {
  // Auth
  login: (email, password) => axios.post(`${apiBase()}/auth/login`, { email, password }),
  signup: (data) => axios.post(`${apiBase()}/auth/signup`, data),
  getMe: () => axios.get(`${apiBase()}/auth/me`),
  forgotPassword: (email) => axios.post(`${apiBase()}/auth/forgot-password`, { email }),
  resetPassword: (token, newPassword) => axios.post(`${apiBase()}/auth/reset-password`, { token, new_password: newPassword }),
  verifyResetToken: (token) => axios.get(`${apiBase()}/auth/verify-reset-token/${token}`),

  // Client
  getClientDashboard: () => axios.get(`${apiBase()}/client/dashboard`),
  getClientPromos: () => axios.get(`${apiBase()}/client/promos`),
  dismissClientPromo: (promoKey) => axios.post(`${apiBase()}/client/promos/dismiss`, { promo_key: promoKey }),
  hopClientPromo: (promoKey) => axios.post(`${apiBase()}/client/promos/${promoKey}/hop`),
  createWebsite: (data) => axios.post(`${apiBase()}/client/websites`, data, { timeout: 300000 }),
  publishWebsite: (websiteId, data) => axios.post(`${apiBase()}/client/websites/${websiteId}/publish`, data, { timeout: 180000 }),
  checkWebAddress: (label, base) => axios.get(`${apiBase()}/client/web-address/check`, { params: base ? { label, base } : { label } }),
  claimWebAddress: (label, base) => axios.post(`${apiBase()}/client/web-address`, base ? { label, base } : { label }),
  getWebAddressOptions: () => axios.get(`${apiBase()}/client/web-address/options`),
  getPlans: (tld) => axios.get(`${apiBase()}/plans`, { params: tld ? { tld } : {} }),
  getCommerce: (websiteId) => axios.get(`${apiBase()}/client/websites/${websiteId}/commerce`),
  saveCommerce: (websiteId, data) => axios.put(`${apiBase()}/client/websites/${websiteId}/commerce`, data),
  startPlanCheckout: (data) => axios.post(`${apiBase()}/client/plans/checkout`, data),
  createEmail: (data) => axios.post(`${apiBase()}/client/emails`, data),
  createEmailCheckout: (data) => axios.post(`${apiBase()}/client/emails/checkout`, data),
  createEmailForward: (data) => axios.post(`${apiBase()}/client/emails/forward`, data),
  refreshEmailForward: (emailId) => axios.post(`${apiBase()}/client/emails/${emailId}/refresh`),

  // AI Wizard
  generateAIContent: (data) => axios.post(`${apiBase()}/ai-wizard/generate`, data),

  // Business Formation
  getFormationProgress: () => axios.get(`${apiBase()}/client/formation-progress`),
  saveFormationProgress: (data) => axios.post(`${apiBase()}/client/formation-progress`, data),

  // Pricing
  getPricing: () => axios.get(`${apiBase()}/pricing`),
  getDomainPricing: () => axios.get(`${apiBase()}/pricing/domains`),

  // Domains
  searchDomains: (query) => axios.post(`${apiBase()}/domains/search`, { query }),
  searchDomainsPublic: (query) => axios.post(`${apiBase()}/domains/search-public`, { query }),
  domainCheckout: (data) => axios.post(`${apiBase()}/domains/checkout`, data),
  existingDomainCheckout: (data) => axios.post(`${apiBase()}/domains/add-existing`, data),
  quoteDomainTransfer: (domain) => axios.get(`${apiBase()}/domains/transfer-quote`, { params: { domain } }),
  transferDomainIn: (data) => axios.post(`${apiBase()}/domains/transfer-in`, data),
  registerDomain: (data) => axios.post(`${apiBase()}/domains/register`, data),
  getDomainStatus: (id) => axios.get(`${apiBase()}/domains/${id}/status`),

  // Tickets
  getTickets: () => axios.get(`${apiBase()}/tickets`),
  createTicket: (data) => axios.post(`${apiBase()}/tickets`, data),
  getTicketMessages: (id) => axios.get(`${apiBase()}/tickets/${id}/messages`),
  sendTicketMessage: (id, message) => axios.post(`${apiBase()}/tickets/${id}/messages`, { message }),

  // Web3
  getWeb3Domains: () => axios.get(`${apiBase()}/web3-domains`),
  addWeb3Domain: (data) => axios.post(`${apiBase()}/web3-domains`, data),

  // Payments
  createCheckout: (planType, originUrl) => axios.post(`${apiBase()}/payments/checkout`, { plan_type: planType, origin_url: originUrl }),
  checkPaymentStatus: (sessionId) => axios.get(`${apiBase()}/payments/status/${sessionId}`),

  // Referrals
  getReferralInfo: () => axios.get(`${apiBase()}/referrals`),
  getAdminReferrals: () => axios.get(`${apiBase()}/admin/referrals`),

  // Subscriptions
  upgradeSubscription: (planType, originUrl) => axios.put(`${apiBase()}/subscriptions/upgrade`, { plan_type: planType, origin_url: originUrl }),

  // Divi Theme
  getDiviThemeStatus: () => axios.get(`${apiBase()}/admin/divi-theme`),
  saveDiviActivation: (key) => axios.post(`${apiBase()}/admin/divi-theme/activation`, { activation_key: key }),
  saveDiviCredentials: (username, password) => axios.post(`${apiBase()}/admin/divi-theme/credentials`, { username, password }),
  getDiviProvisioningPipeline: () => axios.get(`${apiBase()}/admin/divi-theme/provisioning-pipeline`),
  getWebsiteDetail: (id) => axios.get(`${apiBase()}/client/websites/${id}`),

  // Admin
  getAdminStats: () => axios.get(`${apiBase()}/admin/stats`),
  getAdminClients: () => axios.get(`${apiBase()}/admin/clients`),
  toggleFreeHosting: (clientId) => axios.put(`${apiBase()}/admin/clients/${clientId}/free-hosting`),
  deleteAdminClient: (clientId) => axios.delete(`${apiBase()}/admin/clients/${clientId}`),
  bulkDeleteEmptyClients: () => axios.post(`${apiBase()}/admin/clients/bulk-delete-empty`),
  sendAdminPasswordReset: (clientId) => axios.post(`${apiBase()}/admin/clients/${clientId}/send-reset`),
  getAdminWebsites: () => axios.get(`${apiBase()}/admin/websites`),
  createAdminWebsite: (data) => axios.post(`${apiBase()}/admin/websites`, data, { timeout: 300000 }),
  deleteAdminWebsite: (id, data) => axios.post(`${apiBase()}/admin/websites/${id}/delete`, data),
  flagWebsiteContent: (id, data) => axios.post(`${apiBase()}/admin/websites/${id}/content-policy`, data),
  reserveAdminLabel: (data) => axios.post(`${apiBase()}/admin/labels`, data),
  getSharedDomains: () => axios.get(`${apiBase()}/admin/shared-domains`),
  saveSharedDomains: (data) => axios.put(`${apiBase()}/admin/shared-domains`, data),
  releaseAdminLabel: (id) => axios.delete(`${apiBase()}/admin/labels/${id}`),
  getAdminWebsiteAccess: (id) => axios.get(`${apiBase()}/admin/websites/${id}/access`),
  getAdminWebsiteStatus: (id) => axios.get(`${apiBase()}/admin/websites/${id}/status`),
  reprovisionWebsite: (id) => axios.post(`${apiBase()}/admin/websites/${id}/reprovision`),
  // Website team: the owner plus any number of editors.
  getWebsiteMembers: (id) => axios.get(`${apiBase()}/client/websites/${id}/members`),
  addWebsiteMember: (id, data) => axios.post(`${apiBase()}/client/websites/${id}/members`, data, { timeout: 60000 }),
  removeWebsiteMember: (id, email) => axios.delete(`${apiBase()}/client/websites/${id}/members`, { params: { email } }),
  transferWebsiteOwner: (id, data) => axios.post(`${apiBase()}/admin/websites/${id}/transfer`, data, { timeout: 120000 }),
  resendWebsiteInvite: (id, data) => axios.post(`${apiBase()}/admin/websites/${id}/invite`, data || {}),
  transferClientWebsite: (id, data) => axios.post(`${apiBase()}/client/websites/${id}/transfer`, data),
  get: (path, config) => axios.get(`${apiBase()}${path.startsWith('/') ? path : `/${path}`}`, config),
  addAdminDomain: (data) => axios.post(`${apiBase()}/admin/domains`, data),
  attachAdminDomain: (websiteId, data) => axios.post(`${apiBase()}/admin/websites/${websiteId}/attach-domain`, data),
  transferAdminDomainIn: (websiteId, data) => axios.post(`${apiBase()}/admin/websites/${websiteId}/transfer-in`, data),
  deleteAdminDomain: (id) => axios.delete(`${apiBase()}/admin/domains/${id}`),
  getAdminPayments: () => axios.get(`${apiBase()}/admin/payments`),
  getAdminEmailTasks: () => axios.get(`${apiBase()}/admin/email-tasks`),
  provisionEmail: (emailId) => axios.post(`${apiBase()}/admin/email-tasks/${emailId}/provision`),
  getEmailStaff: () => axios.get(`${apiBase()}/admin/email-staff`),
  setEmailStaff: (email) => axios.post(`${apiBase()}/admin/email-staff`, { email }),
  getIntegrations: () => axios.get(`${apiBase()}/admin/integrations`),
  getHealthDeep: () => axios.get(`${apiBase()}/health`, { params: { deep: 1 } }),
  getAdminAnalytics: (days) => axios.get(`${apiBase()}/admin/analytics?days=${days || 30}`),

  // Coupons
  getAdminCoupons: () => axios.get(`${apiBase()}/admin/coupons`),
  createCoupon: (data) => axios.post(`${apiBase()}/admin/coupons`, data),
  toggleCoupon: (id) => axios.put(`${apiBase()}/admin/coupons/${id}/toggle`),
  deleteCoupon: (id) => axios.delete(`${apiBase()}/admin/coupons/${id}`),
  validateCoupon: (code) => axios.post(`${apiBase()}/coupons/validate`, { code }),
  checkSignupCode: (code) => axios.get(`${apiBase()}/coupons/check`, { params: { code } }),
  redeemCoupon: (code) => axios.post(`${apiBase()}/client/coupons/redeem`, { code }),

  // Bringing an existing website over. Capture reads and keeps; build hands the
  // finished site to its owner. A capture crawls somebody else's server, and a
  // build generates and publishes a site, so both are slower than a page load
  // and are given room rather than the default timeout.
  captureSite: (data) => axios.post(`${apiBase()}/admin/site-import/capture`, data, { timeout: 180000 }),
  listSiteCaptures: () => axios.get(`${apiBase()}/admin/site-import/captures`),
  buildImportedSite: (data) => axios.post(`${apiBase()}/admin/site-import/build`, data, { timeout: 300000 }),
  siteImportOptions: () => axios.get(`${apiBase()}/admin/site-import/options`),
  captureClientSite: (data) => axios.post(`${apiBase()}/client/site-import/capture`, data, { timeout: 180000 }),
  clientSiteImportOptions: () => axios.get(`${apiBase()}/client/site-import/options`),
  buildClientImportedSite: (data) => axios.post(`${apiBase()}/client/site-import/build`, data, { timeout: 300000 }),
};

export default api;
